/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { Link } from 'gatsby';
import FooterFr from '../images/fr-footer.png';
import { useFooterMenuitems } from '../hooks/getFooterMenuItems';
import { useSocialLinks } from '../hooks/getSocialLinks';
import { useFooterContent } from '../hooks/getFooterContent';

function MenuItemLink(data) {
    if (data.type === 'custom') {
        return (
            <a href={data.path} target="_blank" rel="noopener noreferrer">
                {data.title}
            </a>
        );
    }
    if (data.type === 'post_type') {
        const postTypeUrl = data.url
            .split('https://werockthespectrumatlantagym.wrtsfranchise.com/')
            .pop();
        return <Link to={`/${postTypeUrl}`}>{data.title}</Link>;
    }
}

const Footer = () => {
    const menuItems = useFooterMenuitems();
    const socialLinks = useSocialLinks();
    const footerContent = useFooterContent();
    return (
        <>
            <footer className="geo-footer" itemScope itemType="https://schema.org/LocalBusiness">
                <div className='new-footer-section'>
                    <meta itemProp="name" content="We Rock the Spectrum Kids Gym Atlanta" />
                    <meta itemProp="telephone" content="770-680-2535" />
                    <meta itemProp="address" content="614 W Crossville Rd, Roswell, GA 30075" />

                    <p>
                        <strong>We Rock the Spectrum Kids Gym Atlanta</strong> is a sensory-safe indoor playground for kids located at{' '}
                        <span itemProp="address">614 W Crossville Rd, Roswell, GA 30075</span>. We provide inclusive play experiences for children of all abilities, ages 6 months to 13 years.
                    </p>

                    <p>
                        Our gym proudly serves families in <span itemProp="areaServed">Roswell</span>,{' '}
                        <span itemProp="areaServed">Atlanta</span>, <span itemProp="areaServed">Alpharetta</span>, <span itemProp="areaServed">Woodstock</span>,{' '}
                        <span itemProp="areaServed">Sandy Springs</span>, <span itemProp="areaServed">Marietta</span>, <span itemProp="areaServed">Sandy Plains</span>,{' '}
                        <span itemProp="areaServed">East Cobb</span>, <span itemProp="areaServed">Milton</span>, and{' '}
                        <span itemProp="areaServed">Johns Creek</span>.
                    </p>

                    <p>
                        Whether you're looking for <strong>indoor activities for kids</strong>, a <strong>kids play area</strong>, themed <strong>birthday party packages</strong>, inclusive <strong>classes</strong>, or seasonal <strong>camps</strong>, we're your go-to destination for safe, active, and fun experiences.
                    </p>

                    <p>
                        Call us at <a href="tel:+17706802535" itemProp="telephone" className="yellowtxt">(770) 680-2535</a> or visit us to learn more.
                    </p>
                </div>
                {/*     <div className="footaddress">
                    <h2>
                        {footerContent.footer_address}
                        {` `}
                        <span className="ipadhide">|</span>
                        {` `}
                        <span className="yellowtxt">
                            CALL US: {footerContent.footer_phone_number}
                        </span>
                    </h2>
                </div>   */}

                <h3 className="footinst">
                    FOLLOW US ON Facebook & INSTAGRAM {` `}
                    <a
                        className="yellowtxt"
                        href={socialLinks.social_instagram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @WRTSROSWELLATLANTA
                    </a>
                </h3>

                <div className="footer-nav">
                    {menuItems.map(menuItem => (
                        <MenuItemLink
                            path={menuItem.url}
                            url={menuItem.url}
                            title={menuItem.title}
                            type={menuItem.type}
                            hasChildren={menuItem.wordpress_children}
                            key={menuItem.wordpress_id}
                        />
                    ))}
                </div>
                <div className="sign-box-up">
                <p className="sign-box-up-par"><span>JOIN OUR NEWSLETTER!</span><br />Subscribe to get the latest updates on events, classes, and more!</p>
                    <a
                        className="signup-letter-new"
                        href="https://wrts.ctgro.com/Z5Oo42-2TWy"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >SUBSCRIBE</a>
                    </div>
                <div className="headersocial footsoc soc">
                    <a
                        className="soc-facebook"
                        href={socialLinks.social_facebook_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    <a
                        className="soc-instagram"
                        href={socialLinks.social_instagram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    {/* <a
                        className="soc-twitter"
                        href={socialLinks.social_twitter_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                    <a
                        className="soc-pinterest"
                        href={socialLinks.social_pinterest_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a> */}
                    <a
                        className="soc-yelp soc-icon-last"
                        href={socialLinks.social_yelp_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    ></a>
                </div>
                <a
                    href="http://www.franchiseregistry.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img className="footerfr" src={ 'https://werockthespectrumkidsgym.wrtsfranchise.com/wp-content/uploads/2022/07/FRANdata_FranchiseRegistryMember_Logo_2022.png' } alt="footer fr" />
                </a>
            </footer>
        </>
    );
};
export default Footer;
